import React from "react";
import { Route, Redirect } from "react-router-dom";

/**
 * Racine de l'espace CP manager.
 *
 * Le rôle est purement administratif : un manager n'accède pas à l'app client
 * et n'a pas de passerelle de retour. La garde fonctionne donc dans les deux
 * sens — `ManagerRoute` bloque les non-managers, et `WhiteListRoutes` renvoie
 * les managers ici depuis toute route client.
 */
export const MANAGER_ROOT = "/manager";

export const MANAGER_ROUTES = {
  overview: MANAGER_ROOT,
  orders: `${MANAGER_ROOT}/orders`,
  residents: `${MANAGER_ROOT}/residents`,
  labels: `${MANAGER_ROOT}/labels`,
  monthly: `${MANAGER_ROOT}/monthly`,
  invoicing: `${MANAGER_ROOT}/invoicing`,
};

export const residentPath = (residentId) => `${MANAGER_ROUTES.residents}/${residentId}`;

export const isManager = (user) => user?.is_company_manager === true;

export const isManagerPath = (pathname = "") =>
  pathname === MANAGER_ROOT || pathname.startsWith(`${MANAGER_ROOT}/`);

/**
 * Destination après authentification.
 *
 * Appelé par les trois chemins d'auth (login email, login Google, reprise de
 * session). Router uniquement depuis le composant SignIn laisserait la
 * connexion Google contourner la redirection.
 */
export const landingPathFor = (user, fallback = "/home") =>
  isManager(user) ? MANAGER_ROOT : fallback;

/** Route réservée aux managers authentifiés. */
export function ManagerRoute({ component: Component, authed, user, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (authed !== true) {
          return <Redirect to={{ pathname: "/sign-in", state: { from: props.location } }} />;
        }
        if (!isManager(user)) {
          return <Redirect to={{ pathname: "/home" }} />;
        }
        return <Component {...props} />;
      }}
    />
  );
}
